import create from "zustand";
import { getAllExpositors } from "../services/expositor.service";
import { getAllEvents } from "../services/event.service";
import { getAllSubscriptions } from "../services/subscriptions.service";
import { getAllBios } from "../services/bio.service";

export const useAdminStore = create(set =>( {
  users: [],
  events: [],
  subscriptions: [],
  bios: [],
  fetch: async () => {
    const users = (await (await getAllExpositors()).json());
    const events = await getAllEvents();
    const subscriptions = (await getAllSubscriptions());
    const bios = (await getAllBios());
    
    set({
      users: users,
      events: events,
      subscriptions: subscriptions,
      bios: bios
    })
  }
}))